<div class="test-form">
    <h2>Test Display</h2>
    <form (ngSubmit)="navigate()">
        <label>
            Site ID
            <input type="text" [(ngModel)]="siteId" name="siteId" placeholder="e.g. site-1" required />
        </label>
        <label>
            Display ID
            <input type="text" [(ngModel)]="displayId" name="displayId" placeholder="e.g. display-1" required />
        </label>
        <button type="submit" [disabled]="!siteId.trim() || !displayId.trim()">Go to Display</button>
    </form>
</div>